import * as React from 'react'
import PropTypes from 'prop-types'
import * as PopoverPrimitive from '@radix-ui/react-popover'

const Popover = PopoverPrimitive.Root

const PopoverTrigger = PopoverPrimitive.Trigger

const PopoverContent = React.forwardRef(({ className, align = 'center', sideOffset = 4, ...props }, ref) => (
  <PopoverPrimitive.Portal>
    <PopoverPrimitive.Content
      ref={ref}
      align={align}
      sideOffset={sideOffset}
      onPointerDownOutside={(e) => {
        const isDrawerOverlay = e.target.closest('[data-vaul-drawer]')
        if (isDrawerOverlay) {
          e.preventDefault()
        }
      }}
      onEscapeKeyDown={(e) => {
        e.stopPropagation()
      }}
      className={`z-[10000] w-72 rounded-md border border-gray-200 bg-white p-4 text-gray-900 shadow-lg outline-none pointer-events-auto data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2 ${
        className || ''
      }`}
      {...props}
    />
  </PopoverPrimitive.Portal>
))
PopoverContent.displayName = PopoverPrimitive.Content.displayName

PopoverContent.propTypes = {
  className: PropTypes.string,
  align: PropTypes.oneOf(['start', 'center', 'end']),
  sideOffset: PropTypes.number
}

export { Popover, PopoverTrigger, PopoverContent }
